module.exports = __webpack_public_path__ + "img/01宋雷.b0da4b4f.jpg";